import { AxiosResponse } from 'axios'
import React, { Fragment, useEffect, useState } from 'react'
import { StepperControls } from '../../../components/StepperTypes/StepperTypes'
import { useApi } from '../../../hooks/useApi'
import { AsnReceiveFilters, AsnToReceive } from '../Interfaces'
import { CircularProgress, Container, Typography } from '@mui/material'
import { PreviousStep } from './PreviousStep'
import { AsnDetailSelection } from './AsnDetailSelection'
import { stepEnum } from '../enum'
import { Status } from '../../../hooks/useFetchState'
import { CollapseButtonV2 } from '../../../components/UI/CollapseButton/CollapseButtonV2'

interface AsnSelectionProps {
  controls: StepperControls
  getAsnSummary: (filters: AsnReceiveFilters) => Promise<AxiosResponse<any>>
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const AsnSelection: React.FC<AsnSelectionProps> = ({
  controls,
  getAsnSummary,
  openSnackBar
}) => {
  const { callApi, state } = useApi()
  const [selectedASN, setSelectedASN] = useState<AsnToReceive[]>([])
  const filters = controls.currentState as AsnReceiveFilters
  const requestAsnToReceive = async () => {
    callApi(getAsnSummary(filters))
      .then((response: AsnToReceive[]) => {
        setSelectedASN(response)
      })
      .catch((error: any) => {
        openSnackBar(error, false)
      })
  }

  useEffect(() => {
    requestAsnToReceive()
  }, [])

  return (
    <Fragment>
      <PreviousStep controls={controls} specificStep={stepEnum.asnSearch} />
      {state.status === Status.Loading ? (
        <CircularProgress />
      ) : (
        <Fragment>
          <div>
            <Typography
              variant='h5'
              style={{
                fontSize: '20px',
                marginBottom: '30px'
              }}
            >
              ¿Cuál ASN desea trabajar?
            </Typography>
            <Typography
              component='p'
              variant='h5'
              style={{
                fontSize: '20px',
                marginBottom: '30px'
              }}
            >
              {filters.supplierId && (
                <span>
                  Proveedor: <b>{filters.supplier}</b>
                </span>
              )}
              {filters.supplierOriginId && (
                <span>
                  Origen: <b>{filters.supplierOrigin}</b>
                </span>
              )}
            </Typography>
          </div>
          <Container
            style={{
              maxHeight: 'calc(80vh - 80px)',
              overflowY: 'auto',
              padding: '5px'
            }}
          >
            {selectedASN?.map((asn) => (
              <CollapseButtonV2
                header={asn.asnNumber}
                handleClick={() => {
                  controls.goToStep(stepEnum.asnSummary, asn.asnId)
                }}
                showButton={true}
              >
                <AsnDetailSelection Asn={asn} />
              </CollapseButtonV2>
            ))}
          </Container>
        </Fragment>
      )}
    </Fragment>
  )
}
